let isNewOrderLinkBasketProtectedFlag = false;

export const protectNewOrderLinkBasket = () => {
  isNewOrderLinkBasketProtectedFlag = true;
};

export const releaseNewOrderLinkBasket = () => {
  isNewOrderLinkBasketProtectedFlag = false;
};

export const isNewOrderLinkBasketProtected = () =>
  isNewOrderLinkBasketProtectedFlag;
